/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class OrbitPaginatorIntl extends MatPaginatorIntl {
	override itemsPerPageLabel = 'Rows per page';
	override previousPageLabel = 'Previous page';
	override nextPageLabel = 'Next page';
	override firstPageLabel = 'First page';
	override lastPageLabel = 'Last page';

	override getRangeLabel = (page: number, pageSize: number, length: number): string => {
		const safeLength = Math.max(0, length);
		if (safeLength === 0 || pageSize === 0) return `0 of ${safeLength}`;

		const startIndex = page * pageSize;
		const endIndex = startIndex < safeLength ? Math.min(startIndex + pageSize, safeLength) : startIndex + pageSize;
		return `${startIndex + 1}–${endIndex} of ${safeLength}`;
	};
}
